import { Link } from "react-router-dom";
import "../styles/NotFoundPage.css"; // Import du fichier CSS

export default function NotFoundPage() {
  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-text">
        Oups ! La page que vous recherchez est introuvable.
      </p>
      <Link to="/" className="not-found-button">
        Retour à l'accueil
      </Link>
    </div>
  );
}
